module.exports = __webpack_public_path__ + "static/media/S-13.3eae3f7d.mp3";